import React from "react";
import { Link } from "gatsby";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";

const Hero = () => {
  return (
    <section className="flex px-5 py-24 items-start justify-center flex-col text-white body-font hero-bg">
      <div className="container max-w-7xl mx-auto">
        <h1 className="sm:text-4xl lg:text-6xl text-3xl mb-3 font-medium text-white max-w-xl lg:max-w-3xl mr-auto capitalize font-bold hero-leading">
          Innovitave, Best Quality, Excellent Value
        </h1>
        <p class="sm:text-lg md:text-2xl font-semibold">A brand specialized in industrial tires</p>
        <div className="flex justify-start mt-5">
          <Link to="/#contact">
            <button className="flex items-center text-white bg-blue-800 border-0 py-3 px-6 focus:outline-none hover:bg-blue-900 rounded text-lg transition transition-hover duration-400 ease-in">
              <FontAwesomeIcon icon={faPaperPlane} size="1x" />
              <span className="ml-2">Contact Us</span>
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;
